<template>
  <div class="row text-sm text-neutral q-px-2x-md q-mt-xxl">
    <div class="col-12">
      <StageStepper :stages="userDetails?.stepper_data" class="q-mb-xxl" />
    </div>

    <div class="col-12">
      <div class="row q-col-gutter-y-sm q-col-gutter-x-sm">
        <div class="col-2">
          <span class="text-neutral-80"> Customer </span>
        </div>
        <div class="col-4">
          <span>
            {{ userDetails.po_info?.buyer_name || "-" }}
          </span>
          <div>
            <span class="text-xs text-neutral-70">
              {{ userDetails.po_info?.buyer_gstin || "-" }}
            </span>
          </div>
        </div>
        <div class="col-2">
          <span class="text-neutral-80"> Date </span>
        </div>
        <div class="col-4">
          <span>
            {{ formatDate(userDetails?.date, "DD MMM YYYY") }}
          </span>
        </div>
        <div class="col-2">
          <span class="text-neutral-80"> PO Number </span>
        </div>
        <div class="col-4">
          <PBtn
            flat
            dense
            class="q-pa-none"
            target="_blank"
            :to="`/sales/purchase-orders/${userDetails?.po_id}`"
          >
            <span>
              {{
                userDetails?.po_info?.number ||
                userDetails?.po_info?.internal_number ||
                "-"
              }}
            </span>
          </PBtn>
        </div>
        <div class="col-2">
          <span class="text-neutral-80"> Due Date </span>
        </div>
        <div class="col-4">
          <span>
            {{ formatDate(userDetails?.due_date, "DD MMM YYYY") || "-" }}
          </span>
        </div>
        <div class="col-2">
          <span class="text-neutral-80"> Vehicle No. </span>
        </div>
        <div class="col-4">
          <span>
            {{ userDetails?.vehicle_number }}
          </span>
        </div>
        <div class="col-2">
          <span class="text-neutral-80"> Trade Due Date </span>
        </div>
        <div class="col-4">
          <span>
            {{ formatDate(userDetails?.trade_due_date, "DD MMM YYYY") || "-" }}
          </span>
        </div>
        <div class="col-2">
          <span class="text-neutral-80"> Dispatch From </span>
        </div>
        <div class="col-4 q-pr-xl">
          <span>
            {{ userDetails?.dispatch_address || "-" }}
          </span>
        </div>
        <div class="col-2">
          <span class="text-neutral-80"> Payment Terms </span>
        </div>
        <div class="col-4">
          <span>
            {{ (userDetails?.po_info?.payment_terms || 0) + " days" }}
          </span>
        </div>
      </div>
    </div>
    <!-- Bill To -->
    <div class="col-6 q-pt-md">
      <div class="row">
        <div class="col-12">
          <span class="text-neutral-80">Bill To</span>
        </div>
        <div class="col-11">
          <span>
            {{ userDetails?.billing_address_info?.shop_name }}<br />
            <template
              v-for="(line, index) in billingAddressLines"
              :key="`bill-${index}`"
            >
              {{ line }}
              <br v-if="index < billingAddressLines.length - 1" />
            </template>
          </span>
        </div>
      </div>
    </div>

    <!-- Ship To -->
    <div class="col-6 q-pt-md q-pl-xxs">
      <div class="row">
        <div class="col-12">
          <span class="text-neutral-80">Ship To</span>
        </div>
        <div class="col-11 text-sm">
          <span>
            {{ userDetails?.shipping_address_info?.shop_name }}<br />
            <template
              v-for="(line, index) in shippingAddressLines"
              :key="`ship-${index}`"
            >
              {{ line }}
              <br v-if="index < shippingAddressLines.length - 1" />
            </template>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { date } from "quasar";
import StageStepper from "./StageStepper.vue";

const { formatDate } = date;

const props = defineProps({
  userDetails: {
    type: Object,
    required: true,
  },
  source: {
    type: String,
    default: "",
  },
  module: {
    type: String,
    default: "cn",
  },
});

const formatAddressLines = (address) => {
  return typeof address === "string" ? address.split("\n") : [];
};

const billingAddressLines = computed(() =>
  formatAddressLines(unref(props).userDetails?.billing_address),
);

const shippingAddressLines = computed(() =>
  formatAddressLines(unref(props).userDetails?.shipping_address),
);
</script>
